import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Campaign } from '../campaign.model';
import { CampaignService } from '../campaign.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { sortBy, get, lowerCase, map, chain, unescape } from 'lodash';
import { AppRoutingService } from '../../app-routing.service';
import { Encoder } from '../../../utils/encoder';
import { CampaignListResponse } from '../campaign-list-response.model';
import { CognitoService } from '../../../services/cognito/cognito.service';

@Component({
  selector: 'app-campaign-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class CampaignListComponent implements OnInit {

  alerts: any = {
    newCampaignAdded: {
      show: false,
      type: 'success',
      msg: 'Campaign registered successfully'
    },
    campaignDeleted: {
      show: false,
      type: 'success',
      msg: 'Campaign deleted successfully'
    },
    campaignUpdated: {
      show: false,
      type: 'success',
      msg: 'Campaign updated successfully'
    },
    error: {
      show: false,
      type: 'danger',
      msg: 'An error occurred'
    }
  };

  showAlert: boolean;

  campaignList: Array<Campaign>;
  campaignListResponse: CampaignListResponse;
  nextPageKey?: string;
  campaignName?: string;

  private previousUrl: string;

  constructor(private router: Router, private route: ActivatedRoute,
    private campaignService: CampaignService, private routingService: AppRoutingService, private activatedRoute: ActivatedRoute,
    public cognitoService: CognitoService) {

    this.campaignList = new Array<Campaign>();
    this.showAlert = false;
  }

  ngOnInit() {
    this.alerts.newCampaignAdded.show = this.campaignService.hasJustRegistered;
    this.alerts.campaignDeleted.show = this.campaignService.hasJustDeleted;
    this.alerts.campaignUpdated.show = this.campaignService.hasJustUpdated;
    this.campaignService.hasJustRegistered = false;
    this.campaignService.hasJustDeleted = false;
    this.campaignService.hasJustUpdated = false;
    this.getCampaignList();
    this.activatedRoute.params.subscribe(value => {
      this.campaignName = value.campaignName;
      this.onSearchClick();
    });
  }

  onClosed(dismissedAlert: any): void {
    dismissedAlert.show = false;
  }

  onLoadMoreClick(): void {
    if (this.nextPageKey) {
      this.loadMoreList();
    }
  }

  onSearchClick(): void {
    if (this.campaignName) {
      this.searchList();
    }
    else {
      this.getCampaignList();
    }
  }

  loadMoreList() {
    this.campaignService.getCampaignList(this.nextPageKey)
      .subscribe((res) => {
        this.campaignListResponse = res;
        this.campaignListResponse.items = chain(this.campaignListResponse.items)
          .map(item => {
            item.campaignName = Encoder.decode(item.campaignName);
            item.campaignDesc = Encoder.decode(item.campaignDesc);
            item.brandName = Encoder.decode(item.brandName);
            return item;
          })
          .sortBy((item) => parseInt(item.campaignId)).reverse().value();
        this.campaignList = this.campaignList.concat(this.campaignListResponse.items);
        this.nextPageKey = this.campaignListResponse.nextPageKey;
      }, err => {

      })
  }

  private async searchList() {
    this.campaignList = [];
    this.nextPageKey = '';
    var index = 0;
    while (this.nextPageKey || index == 0) {
      this.campaignListResponse = await this.campaignService.getCampaignList(this.nextPageKey).toPromise();
      this.campaignListResponse.items = chain(this.campaignListResponse.items).reverse().value();
      this.campaignList = this.campaignList.concat(this.campaignListResponse.items);
      this.nextPageKey = this.campaignListResponse.nextPageKey;
      index = 1;
    }

    // Applying decode and unescape on string fields. Sorting by name
    this.campaignList = this.sortCampaignListById(this.campaignList)
      .filter((item) =>
        (item.campaignName.toLowerCase().search(this.campaignName.toLowerCase()) != -1) ||
        (item.campaignId.search(this.campaignName) != -1)
      );

    if (this.campaignList.length === 0) {
      this.showAlert = true;
    }
  }

  private async getCampaignList() {

    const data = this.route.snapshot.data;

    this.campaignListResponse = get(data, ['campaigns'], []);
    this.campaignList = this.campaignListResponse.items;
    this.nextPageKey = this.campaignListResponse.nextPageKey;

    // Get all info and sort it.
    while (this.nextPageKey) {
      this.campaignListResponse = await this.campaignService.getCampaignList(this.nextPageKey).toPromise();
      this.campaignListResponse.items = chain(this.campaignListResponse.items).reverse().value();
      this.campaignList = this.campaignList.concat(this.campaignListResponse.items);
      this.nextPageKey = this.campaignListResponse.nextPageKey;
    }

    // Applying decode and unescape on string fields. Sorting by name
    this.campaignList = this.sortCampaignListById(this.campaignList);

    if (this.campaignList.length === 0) {
      this.showAlert = true;
    }
  }

  private sortCampaignListById(campaignList) {
    return chain(campaignList)
      .map(item => {
        item.campaignName = Encoder.decode(item.campaignName);
        item.campaignDesc = Encoder.decode(item.campaignDesc);
        item.brandName = Encoder.decode(item.brandName);
        return item;
      })
      .sortBy((item) => parseInt(item.campaignId)).reverse().value();
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/list/list.component.ts